import React, { createContext, PropsWithChildren } from 'react'
import { fetchAndActivate, remoteConfig } from '~providers/firebase'

const RemoteConfigContext = createContext({})

const fetchAndActivateRemoteConfig = () => {
  let fetchedRemotely: boolean | null = null

  const promise = fetchAndActivate(remoteConfig)
  promise.then((data) => {
    fetchedRemotely = data
  })

  return {
    read() {
      if (fetchedRemotely === null) {
        throw promise
      }
      return fetchedRemotely
    },
  }
}
const resource = fetchAndActivateRemoteConfig()

const useRemoteConfig = () => resource.read()

export function RemoteConfigProvider({ children }: PropsWithChildren) {
  useRemoteConfig()

  return <RemoteConfigContext.Provider value={{}}>{children}</RemoteConfigContext.Provider>
}
